export enum SharedAnalyticsEvents {
  BlockNumber = 'blk_num',
  UnblockNumber = 'unblk_num',
  RateLimitError = 'rate_limit_error',
  SettingsMenuChanged = 'settings_menu_changed',
  NotificationBannerEnableClicked = 'notification_banner_enable_clicked',
  NotificationBannerGranted = 'notification_banner_granted',
  NotificationBannerBlocked = 'notification_banner_blocked',
  VersionBannerShown = 'version_banner_shown',
  VersionBannerDismissed = 'version_banner_dismissed',
  VersionBannerRefreshed = 'version_banner_refreshed',
  ReleaseNotificationsToggled = 'release_notifications_toggled',
  AnnouncementShown = 'announcement_shown',
  AnnouncementDismissed = 'announcement_dismissed',
  AnnouncementCtaClicked = 'announcement_cta_clicked',
}
